import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {Fragment, useState} from 'react'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {IconChevronRight} from '~/icons/brg-icon-chevron-right'
import {ShieldRankingIcon} from '~/icons/shield-ranking-icon'
import {StarsGroupIcons} from '~/icons/stars-group-icons'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const RankEUSection = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const [isRankSectionOpen, setIsRankSectionOpen] = useState(false)

  const reportClick = useReportWidgetClick()

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'rank-section-eu',
    widget_place: 'middle',
  })

  return (
    <div className="flex flex-col gap-3" ref={widgetRef}>
      <button
        type="button"
        onClick={() => {
          setIsRankSectionOpen(!isRankSectionOpen)
          reportClick({
            widget_name: 'rank-section-eu',
            widget_place: 'middle',
            trigger_type: isRankSectionOpen ? 'expand-button-close' : 'expand-button-open',
          })
        }}
        aria-label="expand-rank-section"
        className="relative z-20 flex h-full w-full flex-row items-center justify-center gap-2 overflow-hidden rounded-2xl bg-amber-200 px-4 py-3 text-center text-base font-medium transition-all duration-200 ease-in-out tablet:justify-start tablet:py-4 [&>.star]:size-7 [&>.star]:fill-amber-300/60"
      >
        <ShieldRankingIcon />
        {translations.RankSection.rankedByExperts}
        <IconChevronRight
          fill="black"
          className={clsx(
            'ml-5 size-5 transition-all duration-200 ease-in-out tablet:ml-auto',
            isRankSectionOpen ? '-rotate-90' : 'rotate-90',
          )}
        />
        <StarsGroupIcons className="absolute right-[30%] tablet:right-0" />
      </button>
      {isRankSectionOpen ? (
        <div className="mx-auto w-full overflow-hidden">
          <div className="flex flex-col gap-5 rounded-xl bg-amber-200 px-8 py-4 tablet:px-3">
            <div className="flex flex-row gap-5 tablet:flex-col">
              <div className="flex w-1/2 flex-col gap-2 tablet:w-full">
                <span className="flex w-[45%] text-xl font-bold tracking-wide tablet:w-[65%]">
                  {translations.RankSection.contentTitleAI}
                </span>
                <span className="flex text-base font-light tracking-wide">
                  {translations.RankSection.contentDescriptionAI}
                </span>
              </div>
              <div className="flex w-1/2 flex-col gap-2 tablet:w-full">
                <span>{translations.RankSection.weAnalyze}</span>
                <div className="flex flex-wrap gap-2">
                  {translations.RankSection.chips.map((chip) => (
                    <Fragment key={`${chip.id}`}>
                      <span className="rounded-2xl bg-white px-3 py-1.5 text-sm text-gray-900">{chip.label}</span>
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
            <span className="self-center text-base font-light text-amber-800">
              <b className="font-medium">{translations.RankSection.contentAnalyzedQty}</b>
              {translations.RankSection.contentAnalyzed}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default RankEUSection
